import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";
import compose from "recompose/compose";
import {
  Paper,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  Grid,
  Typography,
} from "@material-ui/core";
import Ticker from "react-ticker";
import { withStyles } from "@material-ui/core/styles";
import MultiSelect from "../../../../../common/MultiSelect";
import { LeaderboardIcon } from "../../../../../common/SvgIcon";
import IndividualBoard from "./IndividualBoard";
import SubmitCancelBtn from "../../../../../common/SubmitCancelBtn";
import TeamBoard from "./TeamBoard";
import BinaryResponseBoard from "./BinaryResponseBoard";
import {
  updateUserSelectedProgram,
  updateUserSelectedEvent,
} from "../../../../../../redux/user";
import Properties from "../../../../../../properties/Properties";
import ApplicationUtil from "../../../../../../utils/ApplicationUtil";
import ApplicationConstants from "../../../../../../constants/ApplicationConstants";
import {
  getAgeWiseGroupLeaderboard,
  getCustomFields,
} from "../../../../../../apis/eventService";
import NewLeaderboard from "./NewLeaderboard";
import LocationAndAgeWiseLeaderBoard from "./LocationAndAgeWiseLeaderBoard";

const styles = (theme) => ({
  leaderboard: {
    margin: " auto",

    backgroundColor: "#caf0f8",

    paddingBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  dropdownStyling: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    // marginTop: "20px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      marginBottom: "20px",
    },
  },
  goBtnStyling: {
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "12px",
    },
  },
  container_top: {
    /* width: 20%; */
    display: "flex",
    alignItems: "center",

    justifyContent: "flex-start",
    margin: 0,
    marginLeft: "5%",
    marginTop: "20px",
  },
  input: {
    marginLeft: "1%",
    maxWidth: "260px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "15%",
      maxWidth: "auto",
    },
  },

  leaderboardTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // backgroundColor: "rgb(40, 131, 181)",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
    margin: "auto",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "-8px",
    },
  },
  radioStyling: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      justifyContent: "space-evenly",
      flexWrap: "wrap",
      // flexDirection: "column",
    },
  },
  radioStyle: {
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      marginLeft: "13px",
      paddingLeft: "5px",
      marginRight: "2px",
    },
  },
  labelStyling: {
    "& .MuiTypography-body1": {
      fontSize: "20px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px",
      },
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-11px",
      marginRight: 0,
      padding: 0,
      marginTop: "15px",
    },
  },
});
class Leaderboard extends Component {
  constructor(props) {
    super(props);
    const { classes, challengeType, noTitle, width } = this.props;

    this.state = {
      radioValue:
        challengeType?.challengeType === "TEAM"
          ? "team"
          : challengeType?.showIndividual && challengeType?.showAgeGroup
            ? "individual"
            : !challengeType?.showIndividual && challengeType?.showAgeGroup
              ? Properties?.ageWiseGroupRadioValue
              : challengeType?.showCustomFieldLeaderboard &&
                  challengeType?.showIndividual
                ? "individual"
                : "individual",
      showRunnerGroupGraph: challengeType?.showRunnerGroupGraph,
      showCustomFieldLeaderboard: challengeType?.showCustomFieldLeaderboard,
      // showCustomFieldLeaderboard: true,
      fieldResponseDtos: [],
      showFamilyGroup: false,
      message: true,
      programEventList: [],
      selectedProgramEvent: {},
      summeryGeneratedEvents: [],
      ageWiseData: [],
    };
  }

  handleRadioChange = (event) => {
    event.preventDefault();
    const value = event.target.value;
    this.setState({
      radioValue: value,
    });
  };

  componentDidUpdate = (previousProps) => {
    if (this.props.categoryDTO !== previousProps.categoryDTO) {
      this.setState({
        categoryDTO: this.props.categoryDTO,
      });
    }

    if (
      this.props.challengeType?.challengeType !==
      previousProps?.challengeType?.challengeType
    ) {
      this.setState({
        radioValue:
          this.props.challengeType?.challengeType === "TEAM"
            ? "team"
            : "individual",
        showRunnerGroupGraph: this.props.challengeType?.showRunnerGroupGraph,
      });
    }

    if (
      this.props?.challengeType?.id !== previousProps?.challengeType?.id ||
      this.props?.challengeType?.showAgeGroup !==
        previousProps?.challengeType?.showAgeGroup
    ) {
      if (this.props?.challengeType?.id) {
        getAgeWiseGroupLeaderboard(this.props?.challengeType?.id)
          .then((response) => {
            this.setState({
              ageWiseData: response.data?.ageGroupDTOs,
              ageWiseDataChallengeParameter: response?.data?.challengeParameter,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }

    if (
      this.props?.challengeType?.showCustomFieldLeaderboard !==
        previousProps?.challengeType?.showCustomFieldLeaderboard ||
      this.props?.challengeType?.id !== previousProps?.challengeType?.id
    ) {
      this.fetchCustomFields(this.props.challengeType.id);
      this.setState({
        showCustomFieldLeaderboard:
          this.props.challengeType?.showCustomFieldLeaderboard,
      });
    }

    // if (this.props?.challengeType?.id !== previousProps?.challengeType?.id) {
    //   if (this.props.challengeType?.id) {
    //     this.fetchCustomFields(this.props.challengeType.id);
    //   }
    // }

    if (
      this.props?.challengeType?.showAgeGroup !==
        previousProps?.challengeType?.showAgeGroup ||
      this.props?.challengeType?.showIndividual !==
        previousProps?.challengeType?.showIndividual
    ) {
      this.setState({
        radioValue:
          this.props.challengeType?.challengeType === "TEAM"
            ? "team"
            : this.props.challengeType?.showIndividual &&
                this.props.challengeType?.showAgeGroup
              ? "individual"
              : !this.props.challengeType?.showIndividual &&
                  this.props.challengeType?.showAgeGroup
                ? Properties?.ageWiseGroupRadioValue
                : "individual",
        showRunnerGroupGraph: this.props.challengeType?.showRunnerGroupGraph,
        showCustomFieldLeaderboard:
          this.props.challengeType?.showCustomFieldLeaderboard,
      });
    }
  };
  componentDidMount = () => {
    let summeryGeneratedEvents;
    let summeryGeneratedChallenges;
    if (this.props.isProgram) {
      let programDetails = ApplicationUtil.getRunnersProgramDetails();
      if (programDetails?.id) {
        if (programDetails) {
          if (programDetails?.eventDTO) {
            let eventDTO = programDetails?.eventDTO || [];
            summeryGeneratedEvents = eventDTO
              .map((x) => {
                if (x.summaryGenerated) {
                  return x;
                }
              })
              .filter(function (element) {
                return element !== undefined;
              });
          }

          if (programDetails?.programChallenges) {
            let programChallenges = programDetails?.programChallenges || [];

            summeryGeneratedChallenges = programChallenges.filter((x) => {
              return (
                x?.programChallengeSettings?.summaryGenerated === "true" &&
                x?.programChallengeType !== "MENTAL_WELLBEING"
              );
            });
          }

          let allSummeryGeneratedEvents;

          if (summeryGeneratedEvents && summeryGeneratedChallenges) {
            allSummeryGeneratedEvents = [
              ...summeryGeneratedEvents,
              ...summeryGeneratedChallenges,
            ];
          } else if (!summeryGeneratedEvents && summeryGeneratedChallenges) {
            allSummeryGeneratedEvents = summeryGeneratedChallenges;
          } else {
            allSummeryGeneratedEvents = summeryGeneratedEvents;
          }
          const defaultSelection = this.isEventOngoing(
            allSummeryGeneratedEvents,
          );
          allSummeryGeneratedEvents = allSummeryGeneratedEvents.filter(
            (event) => event.id !== defaultSelection.id,
          );
          allSummeryGeneratedEvents = [defaultSelection].concat(
            allSummeryGeneratedEvents,
          );

          //Ankit if no data is present then handle then state doesn't get update.
          if (
            allSummeryGeneratedEvents !== undefined &&
            allSummeryGeneratedEvents.length > 0
          ) {
            const otherEvents = allSummeryGeneratedEvents.filter((x) => {
              return x && x.programChallengeType !== "MENTAL_WELLBEING";
            });

            let list = otherEvents
              .filter((x) => x !== null && x !== undefined)
              .map((x) => {
                return {
                  label: x.name,
                  value: x.id,
                };
              });

            this.setState({
              programEventDTO: allSummeryGeneratedEvents,
              programEventList: list,
              selectedProgramEvent: list[0],
              summeryGeneratedEvents: allSummeryGeneratedEvents,
            });

            //1st obj is current ongoing / last ended challenge
            if (list && list?.length > 0) {
              this.handleChangeEventSubmit(list[0]);
            }
          }
        }
      }
    }

    if (
      this.props?.challengeType?.id &&
      this.props?.challengeType?.showAgeGroup
    ) {
      getAgeWiseGroupLeaderboard(this.props?.challengeType?.id)
        .then((response) => {
          this.setState({
            ageWiseData: response.data?.ageGroupDTOs,
            ageWiseDataChallengeParameter: response?.data?.challengeParameter,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (
      this.props.challengeType?.id &&
      this.props?.challengeType?.showCustomFieldLeaderboard
    ) {
      this.fetchCustomFields(this.props.challengeType.id);
    }
  };

  fetchCustomFields = (challengeId) => {
    // Replace with your actual API call
    getCustomFields(challengeId).then((res) => {
      this.setState({ fieldResponseDtos: res.data?.fieldResponseDtos || [] });
    });

    // For now, using your static data as placeholder
    // this.setState({
    //   fieldResponseDtos: ApplicationConstants.fieldResponseDtos,
    // });
  };
  isEventOngoing = (events) => {
    if (events && events.length > 0) {
      const onGoingEvents = events?.filter((event) =>
        moment().isBetween(
          moment(event?.eventLocalStartDate, "DD-MM-YYYY"),
          moment(event?.eventLocalEndDate, "DD-MM-YYYY").add(1, "day"),
        ),
      );
      if (onGoingEvents?.length >= 1) {
        return onGoingEvents[0];
      } else {
        //if there's no ongoing event & events are ended then return latest end date.

        // old - not working
        // var mostRecentDate = new Date(
        //   Math.max.apply(
        //     null,
        //     events.map((e) => {
        //       return new Date(e?.eventLocalEndDate);
        //     })
        //   )
        // );
        // var mostRecentObject = events.filter((e) => {
        //   var d = new Date(e?.eventLocalEndDate);
        //   return d.getTime() == mostRecentDate.getTime();
        // })[0];

        // new - vishal
        const res = events?.reduce((a, b) => {
          return new Date(a?.eventLocalEndDate) > new Date(b?.eventLocalEndDate)
            ? a
            : b;
        }, events[0]);

        // return mostRecentObject ? mostRecentObject : events[0];
        return res ? res : events[0];
      }
    }
  };

  handleOnProgramEventChange = (val) => {
    const { programEventDTO } = this.state;
    let event = programEventDTO?.find((x) => x.id === val?.value);
    this.props.updateUserSelectedEvent(event);
    this.setState({ selectedProgramEvent: val });
  };

  handleChangeEventSubmit = (defaultValue) => {
    const _selectedProgramEvent = defaultValue
      ? defaultValue
      : this.state.selectedProgramEvent;
    this.props.reload(_selectedProgramEvent);
  };

  getChallengeLabel = (id) => {
    if (
      ApplicationConstants.isProd &&
      ApplicationConstants?.challengeLabel_Location_Prod?.includes(id)
    ) {
      return "Cohort";
    } else if (ApplicationConstants?.challengeLabel_Location_QA?.includes(id)) {
      return "Cohort";
    } else if (ApplicationConstants.challengeLabel_Corporate_QA.includes(id)) {
      return "Corporate";
    } else {
      return "Team";
    }
  };

  render() {
    const { classes, challengeType, noTitle, width, isProgram, reload } =
      this.props;
    const {
      radioValue,
      showRunnerGroupGraph,
      ageWiseData,
      ageWiseDataChallengeParameter,
      showCustomFieldLeaderboard,
    } = this.state;
    const isProgramChallenge =
      challengeType?.programChallengeType === "HYDRATION" ||
      challengeType?.programChallengeType === "NO_UNHEALTHY_EATING" ||
      challengeType?.programChallengeType === "ZERO_SUGAR" ||
      challengeType?.programChallengeType === "YOGA" ||
      challengeType?.programChallengeType === "MENTAL_WELLBEING";

    if (
      !challengeType ||
      challengeType === "undefined" ||
      challengeType?.programChallengeType === "MENTAL_WELLBEING"
    ) {
      return (
        <Paper
          className={classes.leaderboard}
          style={{
            width: width ? width : "95%",
            padding: "20px",
            textAlign: "center",
          }}
          elevation={3}
        >
          <h2 style={{ color: "gray" }}>
            No Leaderboard available for this challenge.
          </h2>
        </Paper>
      );
    }

    return (
      <Paper
        className={classes.leaderboard}
        style={{ width: width ? width : "95%" }}
        elevation={3}
      >
        {/* Heading */}
        {!noTitle && (
          <Paper variant="outlined" className={classes.leaderboardTitle}>
            <LeaderboardIcon style={{ fontSize: "50px", color: "#F79824" }} />
            <h1
              style={{
                color: "rgb(40, 131, 181)",
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              LeaderBoard
            </h1>
          </Paper>
        )}
        {/* Radio button options */}
        <form>
          {(ApplicationConstants.isProd &&
            ApplicationConstants?.challengeLabel_Location_Prod?.includes(
              challengeType?.id,
            )) ||
          ApplicationConstants?.challengeLabel_Location_QA?.includes(
            challengeType?.id,
          ) ? (
            //----------------- walk to walk  event --------------
            <FormControl
              component="fieldset"
              // error={error}
              className={classes.formControl}
            >
              <RadioGroup
                className={classes.radioStyling}
                value={radioValue}
                onChange={this.handleRadioChange}
              >
                <FormControlLabel
                  value="individual"
                  control={
                    <Radio
                      color="default"
                      size="small"
                      className={classes.radioStyle}
                    />
                  }
                  label="Individual"
                  className={classes.labelStyling}
                />

                <FormControlLabel
                  value="Cohort"
                  control={
                    <Radio
                      color="default"
                      size="small"
                      className={classes.radioStyle}
                    />
                  }
                  label={
                    this.getChallengeLabel(challengeType?.id)
                    // challengeType?.id === 507 ||
                    // challengeType?.id === 508 ||
                    // challengeType?.id === 515
                    //   ? "Corporate"
                    //   : challengeType?.id === 2473
                    //   ? "Location"
                    //   : "Team"
                  }
                  className={classes.labelStyling}
                />

                <FormControlLabel
                  value="location"
                  control={
                    <Radio
                      color="default"
                      size="small"
                      className={classes.radioStyle}
                    />
                  }
                  label="Location"
                  // disabled
                  className={classes.labelStyling}
                />

                <FormControlLabel
                  value="AgeWise"
                  control={
                    <Radio
                      color="default"
                      size="small"
                      className={classes.radioStyle}
                    />
                  }
                  // disabled
                  label="Age Wise"
                  className={classes.labelStyling}
                />
              </RadioGroup>
            </FormControl>
          ) : (
            // ----------- For all event ---------------
            <FormControl
              component="fieldset"
              // error={error}
              className={classes.formControl}
            >
              <RadioGroup
                className={classes.radioStyling}
                value={radioValue}
                onChange={this.handleRadioChange}
              >
                {(challengeType?.challengeType === "BOTH" ||
                  challengeType?.challengeType === "TEAM_RELAY" ||
                  (challengeType?.challengeType === "TEAM" &&
                    showRunnerGroupGraph == true)) && (
                  <FormControlLabel
                    value="team"
                    control={
                      <Radio
                        color="default"
                        size="small"
                        className={classes.radioStyle}
                      />
                    }
                    label={
                      this.getChallengeLabel(challengeType?.id)
                      // challengeType?.id === 507 ||
                      // challengeType?.id === 508 ||
                      // challengeType?.id === 515
                      //   ? "Corporate"
                      //   : challengeType?.id === 2473
                      //   ? "Location"
                      //   : "Team"
                    }
                    className={classes.labelStyling}
                  />
                )}

                {(challengeType?.challengeType === "BOTH" ||
                  challengeType?.challengeType === "TEAM_RELAY" ||
                  ((challengeType?.challengeType === "INDIVIDUAL" ||
                    challengeType?.challengeType === "RELAY") &&
                    showRunnerGroupGraph == true) ||
                  showCustomFieldLeaderboard == true ||
                  challengeType?.showAgeGroup) &&
                  challengeType?.showIndividual && (
                    <FormControlLabel
                      value="individual"
                      control={
                        <Radio
                          color="default"
                          size="small"
                          className={classes.radioStyle}
                        />
                      }
                      label="Individual"
                      className={classes.labelStyling}
                    />
                  )}

                {showRunnerGroupGraph && (
                  <FormControlLabel
                    value="runnerGroup"
                    control={
                      <Radio
                        color="default"
                        size="small"
                        className={classes.radioStyle}
                      />
                    }
                    label="Runner Group"
                    className={classes.labelStyling}
                  />
                )}

                {challengeType?.showFamilyGroup && (
                  <FormControlLabel
                    value="showFamilyGroup"
                    control={
                      <Radio
                        color="default"
                        size="small"
                        className={classes.radioStyle}
                      />
                    }
                    label="Family Group"
                    className={classes.labelStyling}
                  />
                )}

                {/* if individual and age group both present then show ageGroup radio button */}
                {challengeType?.showAgeGroup &&
                  challengeType?.showIndividual && (
                    <FormControlLabel
                      value={Properties?.ageWiseGroupRadioValue}
                      control={
                        <Radio
                          color="default"
                          size="small"
                          className={classes.radioStyle}
                        />
                      }
                      label="Age Group"
                      className={classes.labelStyling}
                    />
                  )}

                {/* Replace the old Custom Fields FormControlLabel with this */}

                {showCustomFieldLeaderboard &&
                  this.state.fieldResponseDtos
                    .sort((a, b) => a.displayOrder - b.displayOrder)
                    .map((field) => (
                      <FormControlLabel
                        key={field.fieldId}
                        value={`custom_${field.fieldId}`} // Prefix to distinguish from 'individual' or 'team'
                        control={
                          <Radio
                            color="default"
                            size="small"
                            className={classes.radioStyle}
                          />
                        }
                        label={field.displayName}
                        className={classes.labelStyling}
                      />
                    ))}
              </RadioGroup>
            </FormControl>
          )}
        </form>

        {(ApplicationConstants.isProd &&
          ApplicationConstants?.challengeLabel_Location_Prod?.includes(
            challengeType?.id,
          )) ||
        ApplicationConstants?.challengeLabel_Location_QA?.includes(
          challengeType?.id,
        ) ? (
          <>
            {radioValue === "location" ? (
              <LocationAndAgeWiseLeaderBoard radioValue={radioValue} />
            ) : radioValue === "AgeWise" ? (
              <LocationAndAgeWiseLeaderBoard radioValue={radioValue} />
            ) : (
              <NewLeaderboard radioValue={radioValue} />
            )}
          </>
        ) : (
          <>
            {this.props.isProgram && this.state.programEventList.length > 0 && (
              <Grid container className={classes.dropdownStyling}>
                <Grid item xs={4} md={2} style={{}} className={classes.input}>
                  <Typography variant="body2">
                    <span style={{ color: "#727272" }}>
                      {Properties.Label_AllEvents}
                    </span>
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </Typography>

                  <MultiSelect
                    value={this.state.selectedProgramEvent}
                    options={this.state.programEventList}
                    onChange={this.handleOnProgramEventChange}
                    isSearchable={false}
                    // defaultValue={programEventList[0]}
                  />
                </Grid>
                <Grid item xs={4} md={2} className={classes.goBtnStyling}>
                  <SubmitCancelBtn
                    type="submit"
                    label={"Go"}
                    onClick={() => this.handleChangeEventSubmit()}
                    className={classes.goBtn}
                    style={{ width: "55%", margin: "auto", marginTop: "10px" }}
                  />
                </Grid>
              </Grid>
            )}

            {challengeType && challengeType?.tickerText && (
              <div style={{ margin: "auto", width: "90%" }}>
                <Ticker>
                  {() => (
                    <p
                      style={{
                        fontSize: "25px",
                        fontWeight: 600,
                        margin: "10px 0px 10px 75px",
                        whiteSpace: "nowrap",
                        color: "#780000",
                      }}
                    >
                      {challengeType?.tickerText + "."}
                    </p>
                  )}
                </Ticker>
              </div>
            )}

            {(!ApplicationConstants?.challengeLabel_Location_Prod?.includes(
              challengeType?.id,
            ) ||
              !ApplicationConstants?.challengeLabel_Location_QA?.includes(
                challengeType?.id,
              )) && (
              <>
                {/* challengeType?.showIndividual => true then show otherwise hide */}
                {(challengeType?.challengeType === undefined ||
                  challengeType?.challengeType === "INDIVIDUAL"  ||
                  radioValue === "individual") &&
                  !isProgramChallenge &&
                  challengeType?.showIndividual &&
                  radioValue !== Properties.ageWiseGroupRadioValue &&
                  (radioValue === "individual" ) && (
                    <IndividualBoard
                      key={radioValue}
                      
                      fieldResponseDtos={this.state.fieldResponseDtos}
                      defaultStairStepper={this.props.defaultStairStepper}
                      isProgram={isProgram}
                      isOk={true}
                      getSearchedMapResults={this.props.getSearchedMapResults}
                      challengeType={challengeType?.challengeType}
                      categoryDTO={this.state.categoryDTO}
                      reload={reload}
                      radioValue={radioValue}
                      plantedPlant={challengeType?.plantedPlant || 0}
                      totalPlant={challengeType?.totalPlant || 0}
                    />
                  )}
              </>
            )}

            {isProgramChallenge && (
              <BinaryResponseBoard
                challengeType={challengeType}
                isProgram={isProgram}
                reload={reload}
              />
            )}

            {((challengeType?.challengeType === "TEAM" &&
              radioValue === "team") ||
              radioValue === "team") && (
              <TeamBoard
                isProgram={isProgram}
                getSearchedMapResults={this.props.getSearchedMapResults}
                radioValue={radioValue}
                challengeType={challengeType}
                reload={reload}
              />
            )}

            {radioValue === "runnerGroup" && showRunnerGroupGraph && (
              <TeamBoard
                getSearchedMapResults={this.props.getSearchedMapResults}
                radioValue={radioValue}
              />
              // </>
            )}

            {/* family group====================== */}

            {radioValue === "showFamilyGroup" &&
              challengeType?.showFamilyGroup && (
                <TeamBoard
                  // getSearchedMapResults={this.props.getSearchedMapResults}
                  radioValue={radioValue}
                />
                // </>
              )}

            {/*end  family group====================== */}
            {radioValue === Properties?.ageWiseGroupRadioValue && (
              <TeamBoard
                isProgram={isProgram}
                // getSearchedMapResults={this.props.getSearchedMapResults}
                ageWiseData={ageWiseData}
                ageWiseDataChallengeParameter={ageWiseDataChallengeParameter}
                radioValue={radioValue}
                challengeType={challengeType}
                reload={reload}
              />
            )}


{/* custom field UI  */}
              {radioValue.startsWith("custom_")  && this.state.fieldResponseDtos?.length > 0 && (
              <TeamBoard
                // getSearchedMapResults={this.props.getSearchedMapResults}
                data={this.state.fieldResponseDtos}
                // ageWiseDataChallengeParameter={ageWiseDataChallengeParameter}
               fieldID={radioValue.startsWith("custom_") ? radioValue.split("_")[1] : null}
                radioValue={radioValue}
                challengeType={challengeType}
                showCustomFieldLeaderboard={showCustomFieldLeaderboard}
                reload={reload}
              />
            )}
            

            {/* Custom field leaderboard can be added here */}
            {/* Logic to show IndividualBoard for Custom Fields */}
            {/* {(radioValue === "individual" ||
              radioValue.startsWith("custom_")) &&
              !isProgramChallenge &&
              challengeType?.showIndividual && (
                <IndividualBoard
                  key={radioValue} // Important: Forces re-mount when switching between fields
                  // isProgram={isProgram}
                  isOk={true}
                  challengeType={challengeType?.challengeType}
                  radioValue={radioValue}
                  // Pass the ID of the field if it's a custom field
                  customFieldId={
                    radioValue.startsWith("custom_")
                      ? radioValue.split("_")[1]
                      : null
                  }
                  reload={reload}
                  {...this.props}
                />
              )} */}
          </>
        )}
      </Paper>
    );
  }
}

function mapStateToProps(state) {
  return {
    userSelectedProgram: state.user.userSelectedProgram,
    userSelectedEvent: state.user.userSelectedEvent,
  };
}

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
  connect(mapStateToProps, {
    updateUserSelectedProgram,
    updateUserSelectedEvent,
  }),
)(Leaderboard);
